import React from "react";
import "./CarouselHP.css";

export const CarouselItemHP = ({ item, width }) => {
  const imageStyle = {
    backgroundImage: `url(${item.icon})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div className="carousel-item" style={{ width: width }}>
      <div className="carousel-img-container" style={imageStyle}>
        <div className="carousel-title">{item.title}</div>
      </div>
    </div>
  );
};

export default CarouselItemHP;
